module.exports = __webpack_public_path__ + "static/imagine-it-forward-9750e336d0712991160041edac1ef355.jpg";